import styled from "styled-components";

export const LangaugeStyleWrapper = styled.div`
  .p-dropdown .p-dropdown-label {
    display: none;
  }
  .p-dropdown .p-dropdown-trigger {
    // width: 2rem !important;
  }
  .p-button.p-button-link:enabled:active,
  .p-button.p-button-link:not(button):not(a):not(.p-disabled):active {
    background: transparent;
    color: black;
    border-color: transparent;
  }
  .p-button.p-button-link:enabled:hover,
  .p-button.p-button-link:not(button):not(a):not(.p-disabled):hover {
    background: transparent;
    color: black;
    border-color: transparent;
  }
  .language-button {
    display: inline-flex;
    gap: 0.8rem;
    color: inherit;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    min-width: 50px;
    padding: inherit;
    &:focus {
      box-shadow: none !important;
    }
  }
 }
 .lang-menu {
  position: absolute;
  top: 50px;
  left: -90%;
  background-color: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  padding: 0px 20px 30px;
  z-index: 10;
  min-width: 295px;
   
 }
 .lang-heading {
  text-align: initial;
  font-weight: 800;
  font-size: 1rem;
  margin-bottom: 20px;
  margin-top: 20px;
 }
 .lang-card {
  display: flex;
  background-color: #f2f3f5;
  padding: 5px 10px;
  border-radius: 5px;

  cursor: pointer;

  &.lang-selected {
   background-color: #1a1c1f;
   color: #fff;
  }

  .left-part {
   flex-grow: 1;
   .lang-english {
    font-weight: 800;
   }
  }
  .right-part {
   align-self: center;
  }
 }
 .languageLabel {
  padding-right: 6px;
  font-size: 0.9rem;
  font-weight: 400;
 }

 .language-select {
  margin-top: 10px;
  margin-right: 6px;
  .p-splitbutton {
   margin-bottom: 0;
   & > .p-button {
    color: #4c565c;
    padding-right: 0;
    .p-button-label {
     margin-left: 10px;
    }
   }
  }
  .p-dropdown {
   background-color: transparent;
   border: none;
   &.p-focus {
    box-shadow: none;
    border-color: transparent;
   }
  }
 }

 .mobile_language_selector {
  &.language-select {
   margin: 0;
  }
  .language-button {
   min-width: unset;
  }
  .languageLabel {
   padding: 0 4px;
  }
  .pi {
   font-size: 0.5rem;
  }
 }

 @media only screen and (max-width: 767px) {
  .lang-menu {
   left: auto;
   width: auto;
   min-width:unset;
  }
 }
`;
